import React from "react";
import { useTranslation } from "react-i18next";
import { teamMembers } from "./data/home.js";
import { Link } from "react-router-dom";
import SEO from "../components/SEO/index.js";
import { Helmet } from "react-helmet-async";

const About = () => {
    const { t } = useTranslation(["home", "common", "about"]);
    return (
        <div>
            <SEO title={"EGP Vietnam - Company Profile"} description={"EGP Vietnam - Company Profile"} />
            <Helmet>
                <script src="/assets/js/main.js"></script>
            </Helmet>
            <div className="content-wrapper">
                {/* Block IMG-bottom */}
                <section
                    className="bg-blue-lighteen medium-padding120 background-cover cloud-center"
                    style={{ backgroundImage: 'url("/assets/img/clouds19.png")' }}
                >
                    <div className="container">
                        <div className="row mb60">
                            <div className="crumina-module crumina-module-img-bottom">
                                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <div className="crumina-module crumina-heading">
                                        <h6 className="heading-sup-title c-white">{t("company", { ns: "about" })}</h6>
                                        <h2 className="heading-title c-white">{t("title", { ns: "about" })}</h2>
                                        <div className="h6 heading-text" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-lg-offset-1 col-md-5 col-sm-4 col-sm-offset-0 col-xs-12">
                                    <Link to="/services" className="btn btn--green btn--with-shadow mb30">
                                        {t("more-service", { ns: "common" })}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* ... end Block IMG-bottom */}
                {/* Info Boxes */}
                <section className="medium-padding100">
                    <div className="container mb60">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="align-center">{t("company", { ns: "about" })}</h1>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="crumina-module crumina-info-box info-box--numbers">
                                    <h5 className="order-number">01.</h5>
                                    <h3 className="h5 info-box-title">{t("who-we-are.title", { ns: "about" })}</h3>
                                    <ul className="" style={{ listStyleType: "disc", marginLeft: 15 }}>
                                        <li>
                                            <ul style={{ listStyleType: "disc" }}>
                                                {Array.from({ length: 3 }).map((_, index) => (
                                                    <li key={index}>
                                                        <b>{t(`who-we-are.${index}.name`, { ns: "about" })}:</b>{" "}
                                                        {t(`who-we-are.${index}.description`, { ns: "about" })}
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="crumina-module crumina-info-box info-box--numbers">
                                    <h5 className="order-number">02.</h5>
                                    <h3 className="h5 info-box-title">{t("different.title", { ns: "about" })}</h3>
                                    <ul className="" style={{ listStyleType: "disc", marginLeft: 15 }}>
                                        <li>
                                            <ul style={{ listStyleType: "disc" }}>
                                                {Array.from({ length: 5 }).map((_, index) => (
                                                    <li key={index}>{t(`different.${index}`, { ns: "about" })}</li>
                                                ))}
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* ... end Info Boxes */}
                {/* Teammembers */}
                <section className="medium-padding100" style={{ padding: "50px 0 !important" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-sm-12 col-xs-12 ">
                                <div className="crumina-module crumina-heading align-center">
                                    <h2 className="heading-title">{t("team.title", { ns: "about" })}</h2>
                                    <div className="heading-text">{t("team.description", { ns: "about" })}</div>
                                </div>
                            </div>
                            <div className="teammembers-wrap">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    {teamMembers.map((item, index) => (
                                        <div key={index} className="crumina-module crumina-teammembers-item" style={{ padding: "0px 0 !important" }}>
                                            <div className="teammembers-thumb">
                                                <img src={item.image_url} alt="team member" />
                                            </div>
                                            <div className="teammember-content">
                                                <div className="teammembers-item-prof">{t(`team.${item.key}.job-title`, { ns: "about" })}</div>
                                                <Link to="#" className="h5 teammembers-item-name">
                                                    {t(`team.${item.key}.name`, { ns: "about" })}
                                                </Link>
                                                <span dangerouslySetInnerHTML={{ __html: t(`team.${item.key}.description`, { ns: "about" }) }}></span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* ... end Teammembers */}
            </div>
        </div>
    );
};

export default About;
